import { useStoreStatus } from "../../hooks/useStoreStatus";
import { cn } from "../../utils/format";

/** Indicador "Aberto agora / Fechado" (efeito Ninja Pulse). */
export const StatusLoja = ({ className }: { className?: string }) => {
  const status = useStoreStatus();

  return (
    <div
      aria-live="polite"
      className={cn(
        "inline-flex items-center gap-2 rounded-full border px-3 py-1.5 text-xs font-semibold",
        status.isOpen
          ? "border-success/30 bg-success/10 text-success"
          : "border-danger/30 bg-danger/10 text-danger",
        className,
      )}
    >
      <span className="relative flex size-2">
        {status.isOpen && (
          <span className="absolute inline-flex size-full animate-ping rounded-full bg-success opacity-75 motion-reduce:hidden" />
        )}
        <span className={cn("relative inline-flex size-2 rounded-full", status.isOpen ? "bg-success" : "bg-danger")} />
      </span>
      {status.message}
    </div>
  );
};
